import React from 'react';
import TreeView from '@zippytech/react-toolkit/TreeView';
import { withRouter } from 'react-router-dom';
import '@zippytech/react-toolkit/TreeView/index.css';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { Grid } from 'semantic-ui-react';
import ContentTree from './../../Initiatives/BrowserPane/contentTree';
import LabelWithCount from '../../../common/LabelWithCount';

@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext(props.name);
  }
})

class UserTree extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };

  }

  nodeStyle = (nodeProps) => {
    if (this.props.userTreeSelectedPathValue && this.props.userTreeSelectedPathValue.toString() === nodeProps.path.toString() && (this.props.mainAreaContext === "USERS" || this.props.mainAreaContext === "Permissions")) {
      return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
    } else {
      return { color: '#6b6b6b', fontFamily: 'montserrat-normal', fontWeight: 'normal' }
    }
  }


  async onSelectionChange(selectedMap) {
    const history = this.props.history;
    if (selectedMap.node.value === 'Permissions') {
      await dispatch.users.userTreeSelectedPath(selectedMap.path)
      await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
      await dispatch.organizationUnit.showResourecePane(null);
      history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/permissions`);
    }
    else {
      await dispatch.app.showToolbar(true)
      await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
      await dispatch.invite.storeUserRole(selectedMap.node.value);
      await dispatch.community.addMainAreaContext('USERS');
      await dispatch.organizationUnit.showResourecePane(null);
      await dispatch.organizationUnit.landingPageFlagSet(false);
      await dispatch.users.setSearchUserQuery({})
      await dispatch.organizationUnit.showDeleteDisabled(false)
      await dispatch.users.userTreeSelectedPath(selectedMap.path)

      if (selectedMap.node.value === 'users' || selectedMap.path === "0") {
        await dispatch.organizationTab.getUsersTreeAsync({ id: this.props.orgUniqueId, accountId: this.props.match.params.accountId });
      }
      else if (selectedMap.node.value === 'workspaceOwner') {
        await dispatch.users.setUsersListData(this.props.executiveList);
      }
      else if (selectedMap.node.value === 'Manager') {
        await dispatch.users.setUsersListData(this.props.managerList);
      }
      else if (selectedMap.node.value === 'Member') {
        await dispatch.users.setUsersListData(this.props.memberList);
      }
      else if (selectedMap.node.value === 'Invitations') {
        await dispatch.users.setUsersListData([...this.props.executiveList,...this.props.managerList]);
      }
      history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/userList/${this.props.selectedSubOrg ? this.props.selectedSubOrg._id : this.props.selectedOrganisation.id}/${selectedMap.node.value}`);
    }

  }

  render() {
    let executiveFlag = false, isAccountOwner = false;
    if (this.props.user && this.props.user.accounts) {
      let ownedAccount = this.props.user.accounts.filter(account => { return (account.role === "customerAdmin" && account.id.toString() === this.props.selectedAccount._id.toString()) });
      if (ownedAccount.length > 0) {
        isAccountOwner = true;
      }
    }
    if (this.props.orgUniqueId !== this.props.match.params.workspaceId) {
      executiveFlag = true;
    }
    else {
      executiveFlag = false;
    }
    let executiveLength = !executiveFlag ? this.props.executiveList.length : '';
    let ExecutivesLabelWithCount = <LabelWithCount label="Workspace Owner" count={executiveLength} />;
    let ManagerLabelWithCount = <LabelWithCount label="Managers" count={this.props.managerList.length} />;
    let MembersLabelWithCount = <LabelWithCount label="Members" count={this.props.memberList.length} />;
    let InvitationsWithCount = <strong style={{ margin: "0 0 0 8px" }}><LabelWithCount labelClass="bg-blue" label="Invitations" count={this.props.invites && this.props.invites.data && this.props.invites.data.length ? this.props.invites.total : 0} /></strong>;
    let totalUser = executiveLength + this.props.managerList.length + this.props.memberList.length

    let components = [
      {
        label: <strong> <LabelWithCount labelClass="bg-blue" label="Users & Roles" count={totalUser} /> </strong>,
        value: "users",
        nodes: [
          {
            label: ExecutivesLabelWithCount,
            value: 'workspaceOwner',
          },
          {
            label: ManagerLabelWithCount,
            value: 'Manager',
          },
          {
            label: MembersLabelWithCount,
            value: 'Member',
          },
        ],
      },
      {
        label: InvitationsWithCount,
        value: 'Invitations',
      }
    ];

    const ManagerComponents = [
      {
        label: <strong><LabelWithCount labelClass="bg-blue" label="Users & Roles" count={this.props.managerList.length + this.props.memberList.length} /></strong>,
        value: "users",
        _id: this.props.selectedOrganisation.id,
        parentOrganizationId: this.props.selectedOrganisation.id,
        nodes: [
          {
            label: ManagerLabelWithCount,
            value: 'Manager',
          },
          {
            label: MembersLabelWithCount,
            value: 'Member',
          },
        ],
      },
      {
        label: InvitationsWithCount,
        value: 'Invitations',
      }
    ];

    let checkSelectedActivity = Object.entries(this.props.selectedActivityData).length !== 0 && this.props.selectedActivityData.constructor === Object
    return (
      <React.Fragment>
        <TreeView
          className="browserPane"
          enableSelection={true}
          nodeStyle={this.nodeStyle}
          onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
          dataSource={this.props.orgUniqueId !== this.props.selectedOrganisation.id ? ManagerComponents : components}
          singleSelect={true}
          // ref={ref => this.props.userObj.userTabTreeRef = ref}
          enableHoverStyle={false}
          enableKeyboardNavigation={false}
        />

        {this.props.activeTab && this.props.activeTab === 'myactivities' && checkSelectedActivity ?
          <ContentTree  {...this.props} selectedDataById={this.props.selectedActivityData.initiativeId} />
          : ''}
      </React.Fragment>
    );
  }
}

export default withRouter(UserTree);